import {animate, query, style, transition, trigger} from "@angular/animations";

export const slideAnimation = trigger(
  'slide',
  [
    transition('* <=> *',
      [
        query(':enter',
          [
            style({transform: 'translateX(20px)', opacity: 0}),
            animate('200ms ease-out',
              style({transform: 'translateX(0)', opacity: 1}))
          ],
          {optional: true}
        )
      ]
    )
  ]
);

const stuckOn = style({position: 'absolute', width: '100%'});

export const slideLeftEnterAnimation = trigger(
    'slideLeftEnter',
    [
      transition(
        ':enter',
        [
          style({transform: 'translateX(100%)'}),
          stuckOn,
          animate(
            '600ms cubic-bezier(0.65, 0.05, 0.36, 1)',
            style({transform: 'translateX(0)'})
          )
        ]
      )]
  )
;

export const slideLeftLeaveAnimation = trigger(
  'slideLeftLeave',
  [
    transition(
      ':leave',
      [
        stuckOn,
        animate(
          '600ms cubic-bezier(0.65, 0.05, 0.36, 1)',
          style({transform: 'translateX(-100%)'})
        )
      ]
    )]
);

export const preventInitial = trigger(
  'preventInitial',
  [
    transition(
      ':enter',
      []
    )
  ]
);

export const modalSlideAnimation = trigger(
  'slide',
  [
    transition(
      ':enter',
      [
        style({ transform: 'translateX(20px)', opacity: 0 }),
        animate('200ms ease-out',
          style({ transform: 'translateX(0)', opacity: 1 }))
      ]
    ),
    transition(
      ':leave',
      [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate('200ms ease-in',
          style({ transform: 'translateX(-60px)', opacity: 0 }))
      ]
    )
  ]
);

export const scaleAnimation = trigger(
  'scale',
  [
    transition(
      ':enter',
      [
        style({ opacity: 0 }),
        animate('200ms ease-out',
          style({ opacity: 1 }))
      ]
    ),
    transition(
      ':leave',
      [
        style({ opacity: 1 }),
        animate('200ms ease-in',
          style({ opacity: 0 }))
      ]
    )
  ]
);
